export type LeaderboardRow = {
  sponsor_id?: string;
  sponsor_name?: string;
  name?: string;
  theater?: string;
  region?: string;
  gl?: string;
  rank?: number;
  composite?: number;
  data_complete?: boolean;
  tier?: string;
  p1?: number;
  p2?: number;
  health?: number;
  arr_pct?: number;
  delta?: number | null;
  gap?: string;
};

export type LeaderboardSortState = { col: string; dir: "asc" | "desc" };

export type LeaderboardColumnDef = {
  key: string;
  label: string;
  align: "center" | "left" | "right";
};

export const LEADERBOARD_TABLE_COLUMNS: LeaderboardColumnDef[] = [
  { key: "rank", label: "#", align: "left" },
  { key: "sponsor_name", label: "Sponsor", align: "left" },
  { key: "theater", label: "Theater", align: "left" },
  { key: "region", label: "Region", align: "left" },
  { key: "p1", label: "Poll 1 (5pt)", align: "left" },
  { key: "p2", label: "Poll 2 (5pt)", align: "left" },
  { key: "composite", label: "Composite", align: "left" },
  { key: "tier", label: "Tier", align: "left" },
  { key: "delta", label: "Δ Prior", align: "left" },
  { key: "gap", label: "Gap", align: "left" },
];

/** All columns share equal width for balanced spacing. 10 columns = 10% each */
export const LEADERBOARD_TRAILING_EQUAL_WIDTH = "w-[10%]";

export const LEADERBOARD_COLUMN_WIDTHS: Record<string, string> = {
  rank: "w-[4%]",
  sponsor_name: "w-[16%]",
  theater: "w-[10%]",
  region: "w-[10%]",
  p1: "w-[10%]",
  p2: "w-[10%]",
  composite: LEADERBOARD_TRAILING_EQUAL_WIDTH,
  tier: LEADERBOARD_TRAILING_EQUAL_WIDTH,
  delta: LEADERBOARD_TRAILING_EQUAL_WIDTH,
  gap: LEADERBOARD_TRAILING_EQUAL_WIDTH,
};

export {
  leaderboardColAlignClass as colAlignClass,
  leaderboardRowClassName,
} from "../../Utils/Helper/sponsorEngagementUi";

export function sortLeaderboardRows(
  rows: LeaderboardRow[],
  sort: LeaderboardSortState
): LeaderboardRow[] {
  const sorted = [...rows];
  const dir = sort.dir === "desc" ? -1 : 1;
  sorted.sort((a, b) => {
    const av = a[sort.col as keyof LeaderboardRow];
    const bv = b[sort.col as keyof LeaderboardRow];
    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;
    if (typeof av === "number" && typeof bv === "number") {
      return (av - bv) * dir;
    }
    return String(av).localeCompare(String(bv)) * dir;
  });
  return sorted.map((row, i) => ({ ...row, rank: i + 1 }));
}

export function toggleLeaderboardSort(
  prev: LeaderboardSortState,
  col: string
): LeaderboardSortState {
  return prev.col === col
    ? { col, dir: prev.dir === "desc" ? "asc" : "desc" }
    : { col, dir: "desc" };
}
